import React, { useRef, useState, useEffect, useCallback } from 'react';
import Webcam from 'react-webcam';
import { db } from '../firebase-config'; 
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import tfFaceService from '../utils/tensorflow';
import './WebcamCapture.css';

const WebcamCapture = () => {
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const [isDetecting, setIsDetecting] = useState(false);
  const [hasLogged, setHasLogged] = useState(false); // 👈 Controls "Once per day"
  const [lastStatus, setLastStatus] = useState('Active');

  const captureAndProcess = useCallback(async () => {
    // STOP if already logged today
    if (!webcamRef.current || isDetecting || hasLogged) return; 

    const video = webcamRef.current.video;
    if (!video || video.readyState !== 4) return;

    setIsDetecting(true);
    try {
      const faces = await tfFaceService.detectFaces(video);
      if (faces.length > 0) {
        const todayStr = new Date().toLocaleDateString();
        
        setLastStatus('✅ Verified');
        setHasLogged(true); // 👈 Locks the UI so they can't log again

        await addDoc(collection(db, 'attendance'), {
          fullTimestamp: new Date().toISOString(),
          dateLabel: todayStr, 
          createdAt: serverTimestamp(),
          status: 'Verified',
          method: 'TensorFlow.js Liveness'
        });
      }
    } catch (error) {
      console.error('Scan Error:', error);
    } finally {
      setIsDetecting(false);
    }
  }, [isDetecting, hasLogged]);

  useEffect(() => {
    const interval = setInterval(() => captureAndProcess(), 5000);
    return () => clearInterval(interval);
  }, [captureAndProcess]);

  return (
    <div className="webcam-container">
      {hasLogged ? (
        <div className="success-overlay">
          <h2>🎉 Attendance Recorded!</h2>
          <p>You have already checked in for today ({new Date().toLocaleDateString()}).</p>
          <p>See you tomorrow!</p>
        </div>
      ) : (
        <div className="webcam-wrapper">
          <Webcam audio={false} ref={webcamRef} className="webcam-feed" />
          <div className="status-bar">{isDetecting ? '🔍 Scanning...' : lastStatus}</div>
        </div>
      )}
    </div>
  );
};

export default WebcamCapture;